<template>
  <div v-if="detailData" class="event-body">
    <div class="wrap">
      <div class="event-detail-top">
        <h3 v-if="detailData.eventtitle" class="event-d-tit">{{detailData.eventtitle}}</h3>
        <p v-if="detailData.startdate && detailData.startdate" class="event-d-date">{{detailData.announcementdate}}</p>
        <a href="#" @click.prevent="moveList(pageNum)" class="event-list-btn"><img src="../../assets/images/event/icon-table-listback.png" alt=""/><span>목록</span></a>
      </div><!--event-detail-top//-->
       <div class="winner-view">
         <div class="winner-table-wrap">
          <table class="winner-table">
            <caption class="blind">이벤트 당첨자 테이블(이벤트명, 이벤트 기간, 경품내용)</caption>
            <colgroup>
              <col width="125px">
              <col>
              <col width="145px">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th>이벤트명</th>
                <td>{{detailData.eventtitle}}</td>
                <th>이벤트 기간</th>
                <td>{{detailData.startdate}} ~ {{detailData.enddate}}</td>
              </tr>
              <tr>
                <th>경품내용</th>
                <td colspan="3">{{detailData.gift}}</td>
              </tr>
<!--              <tr v-if="event.gift">-->
<!--                <th>경품내용</th>-->
<!--                <td colspan="3">{{event.gift}}</td>-->
<!--              </tr>-->
            </tbody>
          </table>
         </div>
         <div class="winner-desc" v-html="setEnterHtml(detailData.content)"></div><!--winner-desc//-->
       </div>
    </div>
  </div>
</template>

<script>
import { getEventsNoticeDetail } from '@/common/utils/request'
import { setEnterChange } from '@/common/utils/common'
import _ from 'lodash'
export default {
  name: 'app',
  data () {
    return {
      eventId: '',
      pageNum: '1',
      detailData: undefined
    }
  },
  methods: {
    setEnterHtml (content) {
      return setEnterChange(content)
    },
    moveList (page) {
      this.$router.push({
        name: 'event_board_list',
        query: {
          page: page
        }
      })
    }
  },
  created () {
    this.eventId = _.get(this.$route, ['query', 'eventId'], '')
    this.pageNum = Number(_.get(this.$route, ['query', 'page'], '1'))
    if (this.eventId) {
      getEventsNoticeDetail({ eventid: this.eventId }).then(({ data }) => {
        this.detailData = data
      })
    }
  }
}
</script>
<style lang="css" src="@/assets/css/event.css"></style>
